import { useCallback, useEffect, useMemo, useState } from 'react';
import { organizationsApi } from '../services/api';
import {
    flattenAccessibleOrganizations,
    shouldShowOrganizationSwitcher,
} from '../utils/hubRoutes';

export default function useAccessibleOrganizations() {
    const [organizations, setOrganizations] = useState([]);
    const [loading, setLoading] = useState(true);

    const reload = useCallback(async () => {
        setLoading(true);
        try {
            const data = await organizationsApi.getAll();
            setOrganizations(Array.isArray(data) ? data : []);
        } catch (err) {
            console.error('Failed to load organizations:', err);
            setOrganizations([]);
            throw err;
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        reload().catch(() => {});
    }, [reload]);

    const flatOrganizations = useMemo(
        () => flattenAccessibleOrganizations(organizations),
        [organizations],
    );

    return {
        organizations,
        flatOrganizations,
        count: flatOrganizations.length,
        loading,
        reload,
        canSwitchOrganizations: !loading && shouldShowOrganizationSwitcher(flatOrganizations.length),
    };
}
